fragment flexiblePostsFeaturedLatest on flexibleSections_postsFeaturedLatest_BlockType {
    __typename
    title: plaintext
    description: richTextMinimal
}
